<template>
  <div id="stockList">
    <div class="row">
      <div class="three-sixths">
        <p>{{ trans('label_latest_update') }}: {{ latestUpdate }}</p>
      </div>
      <div class="three-sixths">
        <h6 v-if="$store.state.user"
            class="right">
          {{ trans('label_welcome') }} {{ displayName }}
        </h6>
      </div>
    </div>
    <div class="row">
      <a href="#"
         @click="toggleCart()"
         class="btn btn-primary outline right">
        <span v-if="!isCartVisible">{{ trans('label_view_stock') }}</span>
        <span v-else>{{ trans('label_order') }}</span>
      </a>
      <a @click="downloadList"
         class="btn btn-primary right btm-download"
         :disabled="isDownloading">
        {{ !isDownloading ? trans('downloadStockList') : trans('processing') }}
      </a>
      <a v-if="!$store.state.user"
         href="/login"
         class="btn btn-primary right">
        {{ trans('login') }}
      </a>
      <a v-if="$store.state.user"
         href="/wp-login.php?action=logout"
         class="btn btn-primary right">
        {{ trans('logout') }}
      </a>
    </div>
    <template v-if="isCartVisible">
      <p v-if="!$store.state.user"
         class="alert alert-warning">
        <a href="/login">{{ trans('login_to') }}</a> {{ trans('view_prices') }}
        <a href="mailto:info@kwekerijvanderlans.nl?SUBJECT=Aanvraag%20logingegevens%20website"
           target="_blank">{{ trans('account_request') }}</a>
      </p>
      <div class="row">
        <ul v-if="errors">
          <li v-for="(error, index)  of errors" :key="index">
            {{ error.message }}
          </li>
        </ul>
        <ul class="alphabet list-inline">
          <li v-for="(letter, index) in letterFilters"
              :key="index">
            <a href="#"
               v-scroll-to="{el: '#'+letter,container: '#scrollStock'}">
              {{ letter }}
            </a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div id="scrollStock" class="stock">
          <table>
            <tr>
              <th colspan="2">
                {{ trans('stock') }}
              </th>
              <th class="size">
                <span>{{ trans('size') }}</span>
              </th>
              <th class="raise">
                <span v-if="$store.state.user">{{ trans('raise') }}</span>
              </th>
              <th class="price">{{ trans('price') }}</th>
              <th>Aantal</th>
            </tr>
            <tr v-for="(item, index) in $store.state.stock"
                :key="index"
                class="list-item"
                :class="[ item.qty > 0 ? '' : 'disabled']"
                :id="item.hasOwnProperty('desc') ? item.desc.charAt(0).toLowerCase(): ''">
              <template v-if="index !== 'cartChanged'">
                <td>{{ item.qty - (item.cartQty ? item.cartQty : 0) }}</td>
                <td>{{ item.desc }}</td>
                <td class="size">{{ item.size }}</td>
                <td class="raise">
                  <span v-if="$store.state.user">{{ raise(item.cartQty) }}</span>
                </td>
                <td>{{ item.price }}</td>
                <td width="100px;">
                  <input type="number"
                         :max="item.qty"
                         v-model="$store.state.stock[index].cartQty"
                         @blur="addItem(index)"
                         @input="checkInput(index, item.origQty )"
                         @wheel="$event.target.blur()"
                  >
                </td>
              </template>
            </tr>
          </table>
        </div>
      </div>
    </template>
    <template v-else>
      <div id="orderList" class="row">
        <template v-if="!$store.state.cart">
          <p>{{ trans('orderStart') }}</p>
        </template>
        <template v-if="$store.state.cart && $store.state.cart.cartChanged">
          <div class="alert alert-warning">{{ trans('cart_changed') }}</div>
        </template>
        <div class="three-sixths order">
          <div id="scrollOrder">
            <template v-if="$store.state.cart">
              <table>
                <tr>
                  <th colspan="2">
                    {{ trans('label_order') }}
                  </th>
                  <th class="size">
                    <span>{{ trans('size') }}</span>
                  </th>
                  <th class="raise">
                    <span v-if="$store.state.user">{{ trans('raise') }}</span>
                  </th>
                  <th class="price">{{ trans('price') }}</th>
                </tr>
                <tr v-for="(cartItem, index) in $store.state.cart"
                    :key="index"
                    class="list-item"
                    :class="{ 'error': cartItem.isDeleted , 'warning': cartItem.isChanged }">
                  <template v-if="$store.state.stock[index]">
                    <td>{{ cartItem.qty }}</td>
                    <td>{{ cartItem.desc }}</td>
                    <td class="size">{{ $store.state.stock[index].size }}</td>
                    <td class="raise">
                      <span v-if="$store.state.user">{{ raise(cartItem.qty) }}</span>
                    </td>
                    <td>{{ $store.state.stock[index].price }}</td>
                  </template>
                </tr>
              </table>
            </template>
          </div>
        </div>
        <div class="three-sixths">
          <OrderForm/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line
import {config} from "./config";
import {HTTP} from "./http-common";
import Qs from 'qs';
import OrderForm from "./components/OrderForm";

export default {
  name: 'StockList',
  components: {
    OrderForm
  },
  data() {
    return {
      filteredStock: {},
      errors: [],
      letterFilters: [],
      isModalVisible: false,
      isDownloading: false,
      isLoading: true,
      selectedItem: {},
      inputQty: '',
      latestUpdate: null,
      displayName: null,
      alphabetChar: null,
      updated: null,
      isCartVisible: true,
    }
  },
  methods: {
    checkInput(index, itemQty) {
      if (this.$store.state.stock[index].cartQty < 1) {
        this.$store.state.stock[index].cartQty = null
      } else {
        this.$store.state.stock[index].cartQty = Number(this.$store.state.stock[index].cartQty) < Number(itemQty) ? this.$store.state.stock[index].cartQty : itemQty;
      }
    },
    toggleCart() {
      this.isCartVisible = !this.isCartVisible;
    },
    filterFirst(letter) {
      this.filteredStock = this.$store.state.stock.filter(function (item) {
        if (item.hasOwnProperty('desc')) {
          return item.desc.charAt(0).toLowerCase() === letter.toLowerCase();
        }
      });
    },
    showModal(item, index) {
      this.selectedItem = item;
      this.selectedItem.index = index;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    setFilters() {
      for (let item in this.$store.state.stock) {
        if (this.$store.state.stock.hasOwnProperty(item) && typeof this.$store.state.stock[item].desc !== 'undefined') {
          let letter = this.$store.state.stock[item].desc.charAt(0).toLowerCase();
          if (this.letterFilters.indexOf(letter) === -1) {
            this.letterFilters.push(letter);
          }
        }
      }
      this.filteredStock = this.$store.state.stock;
      this.isLoading = false;
    },
    addItem(index) {
      const self = this;
      let data = {
        'action': 'lans_ajax_update_cart',
        'nonce': config.nonce,
        'dataType': 'json',
        'cartItem': {
          code: this.$store.state.stock[index].code,
          value: this.$store.state.stock[index].cartQty,
          desc: this.$store.state.stock[index].desc,
          size: this.$store.state.stock[index].size,
        },
        withCredentials: true,
      };
      return HTTP.post(config.ajaxUrl,
          Qs.stringify(data),
      ).then(response => {
        self.$store.commit('setCart', response.data.data.cart)
      }).catch(e => {
        self.errors.push(e)
      });

    },
    removeItem(index) {
      let cartItem = this.$store.state.cart[index];
      this.filteredStock[cartItem.index].qty = this.filteredStock[cartItem.index].origQty;
      this.storeActions.removeCartItem(index);
    },
    loadStock() {
      const self = this;
      let data = {
        'action': 'lans_ajax_get_stock',
        'nonce': config.nonce,
        'dataType': 'json',
        'user': this.$store.state.user
      };
      return HTTP.post(config.ajaxUrl,
          Qs.stringify(data)
      ).then(response => {
        self.$store.commit('setStock', response.data.data.stock);
        self.$store.commit('setCart', response.data.data.cart);
        self.latestUpdate = response.data.data.latestUpdate;
        self.setFilters();
        this.$scrollTo('#stockList');
      }).catch(e => {
        self.errors.push(e)
      });
    },
    setCustomer() {
      const self = this;
      let data = {
        'action': 'lans_ajax_get_customer',
        'nonce': config.nonce,
        'dataType': 'json',
        'user': this.$store.state.user
      };
      HTTP.post(config.ajaxUrl,
          Qs.stringify(data)
      ).then(response => {
        this.$store.commit('setCustomer', response.data.data);
        self.displayName = response.data.data.displayName;
      }).catch(e => {
        self.errors.push(e)
      });
    },
    downloadList() {
      this.isDownloading = true;
      let data = {
        'action': 'lans_ajax_get_stock_excel',
        'dataType': 'json',
        'nonce': config.nonce,
        'locale': this.$store.state.locale,
        'user': this.$store.state.user
      };
      HTTP.post(config.ajaxUrl,
          Qs.stringify(data)
      ).then(response => {
        if (response.data.data.downloadUrl) {
          let fileName = 'voorraad.xlsx',
              fileURL = response.data.data.downloadUrl;
          if (!window.ActiveXObject) {
            let save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            let evt = new MouseEvent('click', {
              'view': window,
              'bubbles': true,
              'cancelable': false
            });
            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
          }
          // for IE < 11
          else if (!!window.ActiveXObject && document.execCommand) {
            let _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL);
            _window.close();
          }
          data = {
            'action': 'lans_ajax_download_complete',
            'dataType': 'json',
            'fileString': response.data.data.fileString,
            'nonce': config.nonce
          };
          HTTP.post(config.ajaxUrl,
              Qs.stringify(data)
          );
          this.isDownloading = false;
        }
      }).catch(e => {
        this.errors.push(e);
        this.isDownloading = false;
      });
    },
    displayPrice(item, qty) {
      let raise = this.raise(qty)
      let result = parseFloat(item.price) + parseFloat(raise)
      return result.toFixed(3)
    }
  },
  created() {
    this.$store.commit('setUser');
    if (this.$store.state.user) {
      this.setCustomer();
    }
    this.$store.commit('setLocale');
    this.loadStock();
    this.interval = setTimeout(() => this.loadStock(), 600000); // 10 minutes

    this.isLoading = true;
  }
}
</script>

<style scoped>

a {
  cursor: pointer;
}

.error {
  color: rgba(255, 0, 0, 0.7);
}

.warning {
  color: rgba(255, 155, 33, 0.98);
}

.stock table:first-of-type {
  margin-bottom: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

#scrollStock, #scrollOrder {
  overflow: auto;
  height: 800px;
}

#scrollStock input[type=number] {
  float: right;
}

#orderList {
  margin-top: 70px;
}

.list-inline {
  list-style-type: none;
  padding-left: 0;
}

.list-inline > li {
  margin-right: 5px;
  display: inline-block;
  float: left;
}

.list-inline > li:hover {
  cursor: pointer;
}

.alphabet {
  min-height: 50px;
}

tr.list-item:hover {
  cursor: pointer;
}

tr.list-item.disabled {
  cursor: default;
  color: grey;
}

.three-sixths {
  margin-left: 0;
}

.row {
  display: block;
  width: 100%;
}

.row::after {
  clear: both;
}

.btm-download {
  width: 250px;
  text-align: center;
}

.list-item__delete {
  text-align: right;
  font-weight: bold;
  color: rgba(255, 0, 0, 0.7);
}

th > small {
  text-transform: lowercase;
  color: #666;
  font-weight: 400;
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert-success {
  color: #155724;
  background-color: #e8eee9;
  border-color: #d0ddd3;
}

.alert a {
  font-weight: bold;
}

.alert-warning a {
  color: #856404;
}

th.raise{
  color: #856404;
  width: 60px;
  text-align: center;
}

th.size {
  width: 100px;
  text-align: center;
}

th.raise, th.price, th.size {
  font-weight: normal;
  text-transform: lowercase;
}

td.raise, td.size {
  color: #856404;
  font-size: 0.9em;
  text-align: center;
}

td.size, th.size {
  color: inherit;
}


</style>
